/**
 * Application configuration
 * Contains environment-specific settings for the UK Government Data Portal
 */

// Configuration with environment variable fallbacks
const config = {
  // Google OAuth Client ID
  googleClientId: process.env.REACT_APP_GOOGLE_CLIENT_ID || 
    '68704264061-hr5n1gp8a3pc8fc3a42lkq0lpco25j1m.apps.googleusercontent.com',
  
  // API URL (defaults to localhost for development)
  apiUrl: process.env.REACT_APP_API_URL || 'https://a38d8gzwmm.eu-west-2.awsapprunner.com'
};

// Log configuration on startup to help with debugging
console.log('Application config:', {
  googleClientId: config.googleClientId,
  apiUrl: config.apiUrl
});

export default config;
